import { render, staticRenderFns } from "./LpImgDropDown.vue?vue&type=template&id=b3990ade&scoped=true"
import script from "./LpImgDropDown.vue?vue&type=script&lang=js"
export * from "./LpImgDropDown.vue?vue&type=script&lang=js"
import style0 from "./LpImgDropDown.vue?vue&type=style&index=0&id=b3990ade&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3990ade",
  null
  
)

export default component.exports